<template>
  <div class="report view" id="report">
    <div class="overview">
      <div class="page-title">Reports</div>
      <div class="filters">
        <div class="filter">
          <v-select
              v-model="report"
              :items="availableReports"
              label="Choose report"
              item-text="text"
              item-value="key"
              required
              outline
              single-line
          ></v-select>
        </div>
        <div class="filter">
          <fleet-autocomplete
              v-model="selectedFleet"
          ></fleet-autocomplete>
        </div>
        <div class="filter">
          <v-select
              v-model="selectedVehicle"
              :items="vehicles"
              label="Choose vehicle"
              item-text="registrationNumber"
              item-value="id"
              required
              outline
              single-line
          ></v-select>
        </div>
        <div class="filter">
          <p
              class="error--text daterange-error"
              v-if="!isDateRangeOk"
          >
            The maximum interval between dates can be
            {{ maximumDateRange }} days.
          </p>
        </div>
        <div v-if="report !== 'deviceLastReported'" class="filter">
          <date-picker
              v-model="dateRange"
              type="date"
              range
              :clearable="false"
              placeholder="Pick date"
          ></date-picker>
        </div>
        <div class="filter">
          <sp-button
              @click.native="generateReport"
              :disabled="!isDateRangeOk"
              sp-class="no-padding-right"
              small-icon
              icon="arrow-left"
              text="Generate"
          ></sp-button>
        </div>
      </div>
    </div>
    <div class="" v-if="selectedReport !== null">
      <v-data-table
          v-if="selectedReport === 'speed'"
          :headers="headers['speed']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
      >
        <template v-slot:items="props">
          <td>{{ props.item.fleetName }}</td>
          <td>{{ props.item.vehicleRegistrationNumber }}</td>
          <td>{{ dateFormat(props.item.time) }}</td>
          <td>{{ formatSpeed(props.item.vehicleSpeed) }}</td>
          <td>{{ formatSpeed(props.item.speedLimit) }}</td>
        </template>
      </v-data-table>

      <v-data-table
          v-if="selectedReport === 'journey'"
          :headers="headers['journey']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
      >
        <template v-slot:items="props">
          <td>{{ props.item.fleetName }}</td>
          <td>{{ props.item.vehicleRegistrationNumber }}</td>
          <td>{{ dateFormat(props.item.startTime) }}</td>
          <td>{{ dateFormat(props.item.endTime) }}</td>
          <td>{{ props.item.startLocation }}</td>
          <td>{{ props.item.endLocation }}</td>
          <td>{{ props.item.duration }}</td>
          <td>
            {{
              formatMileage(
                  (props.item.kilometers || 0).toFixed(2)
              )
            }}
          </td>
        </template>
      </v-data-table>

      <v-data-table
          v-if="selectedReport === 'event'"
          :headers="headers['event']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
          class="custom-table-style"
      >
        <template
            v-slot:items="props"
            v-if="selectedReport === 'event'"
            class="custom-table-style"
        >
          <td>
            <a
                href="#"
                @click="
                                showEvent({
                                    eventId: props.item.id,
                                    hardwareId: props.item.hardwareId,
                                })
                            "
            >{{
                props.item.eventType != null
                    ? getEventName(props.item.eventType)
                    : "-"
              }}</a
            >
          </td>
          <td>{{ props.item.fleetName }}</td>
          <td>{{ dateFormat(props.item.eventDate) }}</td>
          <td>{{ props.item.driverName || "Any" }}</td>
          <td>
            {{ props.item.vehicleRegistrationNumber || "Unknown" }}
          </td>
          <td>{{ props.item.xAxis }}</td>
          <td>{{ props.item.yAxis }}</td>
          <td>{{ props.item.zAxis }}</td>
          <td>{{ formatSpeed(props.item.speed) }}</td>
          <td>{{ getEventLevelName(props.item.alertLevel) }}</td>

          <td>{{ props.item.address }}</td>
          <td>{{ String(props.item.latitude || '').slice(0, 9) }}</td>
          <td>{{ String(props.item.longitude || '').slice(0, 9) }}</td>
        </template>
      </v-data-table>

      <v-data-table
          v-if="selectedReport === 'eventWithLinks'"
          :headers="headers['eventWithLinks']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
          class="custom-table-style">
        <template
            v-slot:items="props"
            v-if="selectedReport === 'eventWithLinks'"
        >
          <td>
            <a
                href="#"
                @click="
                                showEvent({
                                    eventId: props.item.id,
                                    hardwareId: props.item.hardwareId,
                                })
                            "
            >{{
                props.item.eventType != null
                    ? getEventName(props.item.eventType)
                    : "-"
              }}</a
            >
          </td>
          <td>{{ props.item.fleetName }}</td>
          <td>{{ dateFormat(props.item.eventDate) }}</td>
          <td>{{ props.item.driverName || "Any" }}</td>
          <td>
            {{ props.item.vehicleRegistrationNumber || "Unknown" }}
          </td>
          <td>{{ props.item.xAxis }}</td>
          <td>{{ props.item.yAxis }}</td>
          <td>{{ props.item.zAxis }}</td>
          <td>{{ formatSpeed(props.item.speed) }}</td>
          <td>{{ getEventLevelName(props.item.alertLevel) }}</td>

          <td>{{ props.item.address }}</td>
          <td>{{ String(props.item.latitude || '').slice(0, 9) }}</td>
          <td>{{ String(props.item.longitude || '').slice(0, 9) }}</td>
          <td style="max-width: 200px;    hyphens: none;
    word-break: keep-all; ">
            <a v-for="(url, index) in props.item.medias" :key="url+index" target="_blank" v-bind:href="url">Video
              {{ index + 1 }}{{ props.item.medias.length - 1 > index ? ", " : "" }}</a>

          </td>
        </template>
      </v-data-table>

      <v-data-table
          v-if="selectedReport === 'snapshotsRequests'"
          :headers="headers['snapshotsRequests']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
      >
        <template
            v-slot:items="props"
            v-if="selectedReport === 'snapshotsRequests'"
        >
          <td>{{ props.item.organizationName }}</td>
          <td>{{ props.item.vehicleRegistrationNumber }}</td>
          <td>
            <div v-if="3 === props.item.state">
              <a
                  href="#"
                  @click="
                                    showEvent({
                                        eventId: props.item.eventId,
                                        hardwareId: props.item.hardwareId,
                                    })
                                "
              >{{ getRequestStatusName(props.item.state) }}</a
              >
            </div>
            <div v-if="3 !== props.item.state">
              {{ getRequestStatusName(props.item.state) }}
            </div>
          </td>
          <td>{{ getRequestTypeName(props.item.type) }}</td>
          <td>
            {{
              props.item.createdByName
                  ? dateFormat(
                      props.item.createdOn.slice(0, 19) + "Z"
                  )
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.createdByName
                  ? props.item.createdByName
                  : "Unknown"
            }}
          </td>
          <td>
            {{
              props.item.modifiedOn
                  ? dateFormat(
                      props.item.modifiedOn.slice(0, 19) + "Z"
                  )
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.modifiedByName
                  ? props.item.modifiedByName
                  : "-"
            }}
          </td>
        </template>
      </v-data-table>

      <v-data-table
          v-if="selectedReport === 'deviceLastReported'"
          :headers="headers['deviceLastReported']"
          :items="items"
          item-key="id"
          hide-actions
          :pagination.sync="pagination"
          :page.sync="page"
      >
        <template
            v-slot:items="props"
            v-if="selectedReport === 'deviceLastReported'"
        >
          <td>
            {{
              props.item.hardwareId != null
                  ? props.item.hardwareId
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.vehicle != null
                  ? props.item.vehicle.name
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.organization != null
                  ? props.item.organization.name
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.fleet != null
                  ? props.item.fleet.name
                  : "-"
            }}
          </td>
          <td>
            {{
              props.item.lastReported != null
                  ? dateFormat(
                      props.item.lastReported.slice(0, 19) + "Z"
                  )
                  : "-"
            }}
          </td>
          <td>{{ props.item.enabled ? "YES" : "NO" }}</td>
        </template>
      </v-data-table>

      <div class="table-footer">
        <div class="table-pagination">
          <v-pagination
              v-model="pagination.page"
              :length="pages"
              :total-visible="7"
          ></v-pagination>
        </div>
        <div class="table-buttons">
          <sp-button
              @click.native="exportToXlsx"
              :disabled="items.length === 0"
              sp-class="no-padding-right"
              icon="download"
              text="Export to Xlsx"
          ></sp-button>          <sp-button
              @click.native="exportToCSV"
              :disabled="items.length === 0"
              sp-class="no-padding-right"
              icon="download"
              text="Export to CSV"
          ></sp-button>
          <sp-button
              @click.native="exportToPDF"
              :disabled="items.length === 0"
              sp-class="no-padding-right"
              icon="download"
              text="Export to PDF"
          ></sp-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import {
    formatDate,
    searchEnumById,
    camelCaseToSentence,
    calculateSpeedOrDistanceUnit,
    calculateMileage
} from '@/helpers/Utils'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import jsPDF from 'jspdf'
import { FleetApi, VehicleApi, ReportsApi, MediaRequestApi } from '@/api'
import DatePicker from 'vue2-datepicker'
import autoTable from 'jspdf-autotable'
import { read, utils, writeFileXLSX } from 'xlsx';


const fleetApi = new FleetApi()
const vehicleApi = new VehicleApi()
const reportsApi = new ReportsApi()
const mediaRequestApi = new MediaRequestApi()

export default {
    name: 'Report',
    components: {
        SpButton,
        FleetAutocomplete,
        DatePicker
    },
    async mounted () {
        this.$store.state.isOverlayActive = true
        let fleets = await fleetApi.getFleetList(1, 1000)
        this.$store.state.isOverlayActive = false
        this.fleets = fleets.payload.items

        this.selectedFleet = null
        this.report = this.availableReports[0].key
        this.selectedReport = this.availableReports[0].key

        this.headers.speed[3].text = `Vehicle speed ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.headers.speed[4].text = `Vehicle limit ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.headers.journey[7].text = `Mileage ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.headers.event[8].text = `Speed ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.exports.speed.headers[3].prompt = `Vehicle speed ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.exports.speed.headers[4].prompt = `Vehicle limit ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.exports.journey.headers[7].prompt = `Mileage ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
        this.exports.event.headers[8].prompt = `Speed ${
            0 === this.getSpeedUnit ? ' (km)' : ' (mi)'
        }`
    },
    data () {
        return {
            dateRange: [moment()._d, moment()._d],
            dataPickerDisabled: false,
            report: null,
            availableReports: [
                {
                    key: 'speed',
                    text: 'Over speed report'
                },
                {
                    key: 'journey',
                    text: 'Journey report'
                },
                {
                    key: 'eventWithLinks',
                    text: 'Events with links report'
                },
                {
                    key: 'event',
                    text: 'Events report'
                },
                {
                    key: 'snapshotsRequests',
                    text: 'Media requests'
                },
                {
                    key: 'deviceLastReported',
                    text: 'Device last reported'
                }
            ],
            selectedReport: null,
            fleets: [],
            selectedFleet: null,
            vehicles: [],
            selectedVehicle: '',
            availableDays: ['Today', 'Yesterday', 'Last 2 days', 'Last 7 days'],
            maximumDateRange: 31,
            selectedDay: '',
            isDatePickerFromShow: false,
            isDatePickerToShow: false,
            isDateRangeOk: true,
            headers: {
                speed: [
                    {
                        text: 'Fleet name',
                        name: 'fleetName',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleRegistrationNumber',
                        sortable: false
                    },
                    {
                        text: 'Time',
                        name: 'time',
                        sortable: false,
                        width: 200
                    },
                    {
                        text: `Vehicle speed`,
                        name: 'vehicleSpeed',
                        sortable: false,
                        width: 150
                    },
                    {
                        text: `Vehicle limit`,
                        name: 'speedLimit',
                        sortable: false,
                        width: 150
                    }
                ],
                journey: [
                    {
                        text: 'Fleet name',
                        name: 'fleetName',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleRegistrationNumber',
                        sortable: false
                    },
                    {
                        text: 'Start time',
                        name: 'startTime',
                        sortable: false
                    },
                    {
                        text: 'End time',
                        name: 'endTime',
                        sortable: false
                    },
                    {
                        text: 'Start location',
                        name: 'startLocation',
                        sortable: false
                    },
                    {
                        text: 'End location',
                        name: 'endLocation',
                        sortable: false
                    },
                    {
                        text: 'Duration',
                        name: 'duration',
                        sortable: false
                    },
                    {
                        text: `Mileage`,
                        name: 'mileage',
                        sortable: false
                    }
                ],
                eventWithLinks: [
                    {
                        text: 'Event type',
                        name: 'speed',
                        sortable: false
                    },
                    {
                        text: 'Fleet name',
                        name: 'fleetName',
                        sortable: false
                    },
                    {
                        text: 'Event date',
                        name: 'eventDate',
                        sortable: false
                    },
                    {
                        text: 'Driver name',
                        name: 'driverName',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleRegistrationNumber',
                        sortable: false
                    },
                    {
                        text: 'xAxis',
                        name: 'xAxis',
                        sortable: false
                    },
                    {
                        text: 'yAxis',
                        name: 'yAxis',
                        sortable: false
                    },
                    {
                        text: 'zAxis',
                        name: 'zAxis',
                        sortable: false
                    },
                    {
                        text: `Speed`,
                        name: 'speed',
                        sortable: false
                    },
                    {
                        text: 'Alert level',
                        name: 'speed',
                        sortable: false
                    },
                    {
                        text: 'Address',
                        name: 'address',
                        sortable: false
                    }, {
                        name: 'latitude',
                        text: 'Lat',
                        sortable: false

                    }, {
                        name: 'longitude',
                        text: 'Lng',
                        sortable: false
                    }, {
                        text: 'Medias',
                        name: 'medias',

                        sortable: false
                    }
                ],
                event: [
                    {
                        text: 'Event type',
                        name: 'speed',
                        sortable: false
                    },
                    {
                        text: 'Fleet name',
                        name: 'fleetName',
                        sortable: false
                    },
                    {
                        text: 'Event date',
                        name: 'eventDate',
                        sortable: false
                    },
                    {
                        text: 'Driver name',
                        name: 'driverName',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleRegistrationNumber',
                        sortable: false
                    },
                    {
                        text: 'xAxis',
                        name: 'xAxis',
                        sortable: false
                    },
                    {
                        text: 'yAxis',
                        name: 'yAxis',
                        sortable: false
                    },
                    {
                        text: 'zAxis',
                        name: 'zAxis',
                        sortable: false
                    },
                    {
                        text: `Speed`,
                        name: 'speed',
                        sortable: false
                    },
                    {
                        text: 'Alert level',
                        name: 'speed',
                        sortable: false
                    }, {
                        text: 'Address',
                        name: 'address',
                        sortable: false
                    }, {
                        name: 'latitude',
                        text: 'Lat',
                        sortable: false

                    }, {
                        name: 'longitude',
                        text: 'Lng',
                        sortable: false
                    }
                ],
                snapshotsRequests: [
                    {
                        text: 'Organization',
                        name: 'organizationName',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleRegistrationNumber',
                        sortable: false
                    },
                    {
                        text: 'Status',
                        name: 'status',
                        sortable: false
                    },
                    {
                        text: 'Type',
                        name: 'type',
                        sortable: false
                    },
                    {
                        text: 'Created on',
                        name: 'createdOn',
                        sortable: false
                    },
                    {
                        text: 'Created by',
                        name: 'createdBy',
                        sortable: false
                    },
                    {
                        text: 'Modified on',
                        name: 'modifiedOn',
                        sortable: false
                    },
                    {
                        text: 'Modified by',
                        name: 'modifiedBy',
                        sortable: false
                    }
                ],
                deviceLastReported: [
                    {
                        text: 'Recorder id',
                        name: 'recorderId',
                        sortable: false
                    },
                    {
                        text: 'Vehicle',
                        name: 'vehicleName',
                        sortable: false
                    },
                    {
                        text: 'Organization name',
                        name: 'organizationName',
                        sortable: false
                    },
                    {
                        text: 'Fleet name',
                        name: 'fleetName',
                        sortable: false
                    },
                    {
                        text: 'Last reported',
                        name: 'lastReported',
                        sortable: false
                    },
                    {
                        text: 'Enabled',
                        name: 'enabled',
                        sortable: false
                    }
                ]
            },
            items: [],
            totalItems: 0,
            page: 1,
            pagination: {
                rowsPerPage: 10,
                maxButtons: 5,
                totalItems: 0,
                page: 1
            },
            loading: false,
            additionalStyles: {
                event: {
                    fontSize: 8
                },
                eventWithLinks: {
                    fontSize: 8
                }
            },
            exports: {
                speed: {
                    headers: [
                        {
                            id: 'fleetName',
                            name: 'fleetName',
                            prompt: 'Fleet name',
                            align: 'left',
                            width: 130,
                            padding: 0
                        },
                        {
                            id: 'vehicleRegistrationNumber',
                            name: 'vehicleRegistrationNumber',
                            prompt: 'Vehicle',
                            align: 'left',
                            width: 95,
                            padding: 0
                        },
                        {
                            id: 'time',
                            name: 'time',
                            prompt: 'Time',
                            align: 'left',
                            width: 135,
                            padding: 0
                        },
                        {
                            id: 'vehicleSpeed',
                            name: 'vehicleSpeed',
                            prompt: `Vehicle speed`,
                            align: 'left',
                            width: 105,
                            padding: 0
                        },
                        {
                            id: 'speedLimit',
                            name: 'speedLimit',
                            prompt: `Vehicle limit`,
                            align: 'left',
                            width: 105,
                            padding: 0
                        }
                    ],
                    fileName: 'VehicleOverSpeedReport'
                },
                journey: {
                    headers: [
                        {
                            id: 'fleetName',
                            name: 'fleetName',
                            prompt: 'Fleet name',
                            align: 'left',
                            width: 70,
                            padding: 0
                        },
                        {
                            id: 'vehicleRegistrationNumber',
                            name: 'vehicleRegistrationNumber',
                            prompt: 'Vehicle',
                            align: 'left',
                            width: 60,
                            padding: 0
                        },
                        {
                            id: 'startTime',
                            name: 'startTime',
                            prompt: 'Start time',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'endTime',
                            name: 'endTime',
                            prompt: 'End time',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'startLocation',
                            name: 'startLocation',
                            prompt: 'Start location',
                            align: 'left',
                            width: 95,
                            padding: 0
                        },
                        {
                            id: 'endLocation',
                            name: 'endLocation',
                            prompt: 'End location',
                            align: 'left',
                            width: 85,
                            padding: 0
                        },
                        {
                            id: 'duration',
                            name: 'duration',
                            prompt: 'Duration',
                            align: 'left',
                            width: 55,
                            padding: 0
                        },
                        {
                            id: 'mileage',
                            name: 'mileage',
                            prompt: `Mileage`,
                            align: 'left',
                            width: 70,
                            padding: 0
                        }
                    ],
                    fileName: 'JourneysReport'
                },
                eventWithLinks: {
                    headers: [
                        {
                            id: 'eventType',
                            name: 'eventType',
                            prompt: 'Event type',
                            align: 'left',
                            width: 62,
                            padding: 0
                        },
                        {
                            id: 'fleetName',
                            name: 'fleetName',
                            prompt: 'Fleet name',
                            align: 'left',
                            width: 75,
                            padding: 0
                        },
                        {
                            id: 'eventDate',
                            name: 'eventDate',
                            prompt: 'Event date',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'driverName',
                            name: 'driverName',
                            prompt: 'Driver name',
                            align: 'left',
                            width: 70,
                            padding: 0
                        },
                        {
                            id: 'vehicleRegistrationNumber',
                            name: 'vehicleRegistrationNumber',
                            prompt: 'Registration number',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'xAxis',
                            name: 'xAxis',
                            prompt: 'xAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'yAxis',
                            name: 'yAxis',
                            prompt: 'yAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'zAxis',
                            name: 'zAxis',
                            prompt: 'zAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'speed',
                            name: 'speed',
                            prompt: `Speed`,
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'alertLevel',
                            name: 'alertLevel',
                            prompt: 'Alert type',
                            align: 'left',
                            width: 55,
                            padding: 0
                        }, {
                            id: 'address',
                            name: 'address',
                            prompt: 'Address',
                            align: 'left',
                            width: 55,
                            padding: 0
                        },
                        {
                            id: 'latitude',
                            name: 'latitude',
                            prompt: 'Lat'
                        }, {
                            id: 'longitude',
                            name: 'longitude',
                            prompt: 'Lng'
                        }
                    ],
                    fileName: 'EventsWithLinksReport'
                },
                event: {
                    headers: [
                        {
                            id: 'eventType',
                            name: 'eventType',
                            prompt: 'Event type',
                            align: 'left',
                            width: 62,
                            padding: 0
                        },
                        {
                            id: 'fleetName',
                            name: 'fleetName',
                            prompt: 'Fleet name',
                            align: 'left',
                            width: 75,
                            padding: 0
                        },
                        {
                            id: 'eventDate',
                            name: 'eventDate',
                            prompt: 'Event date',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'driverName',
                            name: 'driverName',
                            prompt: 'Driver name',
                            align: 'left',
                            width: 70,
                            padding: 0
                        },
                        {
                            id: 'vehicleRegistrationNumber',
                            name: 'vehicleRegistrationNumber',
                            prompt: 'Registration number',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'xAxis',
                            name: 'xAxis',
                            prompt: 'xAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'yAxis',
                            name: 'yAxis',
                            prompt: 'yAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'zAxis',
                            name: 'zAxis',
                            prompt: 'zAxis',
                            align: 'left',
                            width: 35,
                            padding: 0
                        },
                        {
                            id: 'speed',
                            name: 'speed',
                            prompt: `Speed`,
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'alertLevel',
                            name: 'alertLevel',
                            prompt: 'Alert type',
                            align: 'left',
                            width: 55,
                            padding: 0
                        },
                        {
                            id: 'address',
                            name: 'address',
                            prompt: 'Address',
                            align: 'left',
                            width: 55,
                            padding: 0
                        },
                        {
                            id: 'latitude',
                            name: 'latitude',
                            prompt: 'Lat'
                        }, {
                            id: 'longitude',
                            name: 'longitude',
                            prompt: 'Lng'
                        }
                    ],
                    fileName: 'EventsNoMediaReport'
                },
                snapshotsRequests: {
                    headers: [
                        {
                            id: 'organizationName',
                            name: 'organizationName',
                            prompt: 'Organization',
                            align: 'left',
                            width: 85,
                            padding: 0
                        },
                        {
                            id: 'vehicleRegistrationNumber',
                            name: 'vehicleRegistrationNumber',
                            prompt: 'Registration number',
                            align: 'left',
                            width: 65,
                            padding: 0
                        },
                        {
                            id: 'status',
                            name: 'status',
                            prompt: 'Status',
                            align: 'left',
                            width: 75,
                            padding: 0
                        },
                        {
                            id: 'type',
                            name: 'type',
                            prompt: 'Type',
                            align: 'left',
                            width: 55,
                            padding: 0
                        },
                        {
                            id: 'createdOn',
                            name: 'createdOn',
                            prompt: 'Created on',
                            align: 'left',
                            width: 120,
                            padding: 0
                        },
                        {
                            id: 'createdBy',
                            name: 'createdBy',
                            prompt: 'Created by',
                            align: 'left',
                            width: 75,
                            padding: 0
                        },
                        {
                            id: 'modifiedOn',
                            name: 'modifiedOn',
                            prompt: 'Modified on',
                            align: 'left',
                            width: 120,
                            padding: 0
                        },
                        {
                            id: 'modifiedBy',
                            name: 'modifiedBy',
                            prompt: 'Modified by',
                            align: 'left',
                            width: 75,
                            padding: 0
                        }
                    ],
                    fileName: 'SnapshotsRequestsReport'
                },
                deviceLastReported: {
                    headers: [
                        {
                            id: 'recorderId',
                            name: 'recorderId',
                            prompt: 'Recorder id',
                            align: 'left',
                            width: 115,
                            padding: 0
                        },
                        {
                            id: 'vehicle',
                            name: 'vehicle',
                            prompt: 'Vehicle',
                            align: 'left',
                            width: 95,
                            padding: 0
                        },
                        {
                            id: 'organizationName',
                            name: 'organizationName',
                            prompt: 'Organization name',
                            align: 'left',
                            width: 105,
                            padding: 0
                        },
                        {
                            id: 'fleetName',
                            name: 'fleetName',
                            prompt: 'Fleet name',
                            align: 'left',
                            width: 105,
                            padding: 0
                        },
                        {
                            id: 'lastReported',
                            name: 'lastReported',
                            prompt: 'Last reported',
                            align: 'left',
                            width: 105,
                            padding: 0
                        },
                        {
                            id: 'enabled',
                            name: 'enabled',
                            prompt: 'Enabled',
                            align: 'left',
                            width: 50,
                            padding: 0
                        }
                    ],
                    fileName: 'DeviceLastReportedReport'
                }
            }
        }
    },
    watch: {
        report: {
            handler: function (value) {
                // this.dataPickerDisabled = 'snapshotsRequests' === value
            },
            deep: true
        },
        selectedFleet: {
            handler: function (value) {
                this.getFleetVehicles()
            },
            deep: true
        },
        dateRange: {
            handler: function (value) {
                let from = moment(value[0])
                let to = moment(value[1])

                let diff = to.diff(from, 'days')

                this.isDateRangeOk = this.maximumDateRange >= diff
            },
            deep: true
        }
    },
    computed: {
        pages () {
            if (
                null == this.pagination.rowsPerPage ||
          null == this.pagination.totalItems
            ) {
                return 0
            }

            return Math.ceil(
                this.pagination.totalItems / this.pagination.rowsPerPage
            )
        },
        ...mapState(['eventTypes', 'eventAlertLevelType']),
        ...mapGetters('authModule', ['getActiveOrganization', 'getSpeedUnit']),
        ...mapGetters('dictionaryModule', [
            'getEventTypes',
            'getDeviceCommandStates',
            'getDeviceCommandTypes',
            'getEventClassifications'
        ]),
        ...mapGetters('brandModule', ['getShowPoweredBy', 'getReportImageUri'])
    },
    methods: {
        async getFleetVehicles () {
            if (null == this.selectedFleet) {
                return
            }

            const response = await vehicleApi.getVehicles({
                skip: 0,
                take: 1000,
                fleetId: this.selectedFleet.id
            })
            this.vehicles = []
            this.vehicles = response.payload.items
            this.vehicles.unshift({
                registrationNumber: 'All',
                id: null
            })

            this.selectedVehicle = this.vehicles[0].id
        },
        formatSpeed (speed) {
            return 0 === this.getSpeedUnit
                ? speed
                : calculateSpeedOrDistanceUnit(speed, 'mi')
        },
        formatMileage (mileage) {
            return 0 === this.getSpeedUnit
                ? mileage
                : calculateMileage(mileage, 'mi')
        },
        async generateReport () {
            this.$store.state.isOverlayActive = true

            let response
            this.selectedReport = this.report

            switch (this.selectedReport) {
                case 'speed':
                    response = await reportsApi.getOverSpeedReport({
                        fleetId: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        vehicleId: this.selectedVehicle,
                        dateFrom: this.dateRange[0].toISOString(),
                        dateTo: this.dateRange[1].toISOString()
                    })
                    break
                case 'journey':
                    response = await reportsApi.getJourneysReport({
                        fleetId: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        vehicleId: this.selectedVehicle,
                        dateFrom: this.dateRange[0].toISOString(),
                        dateTo: this.dateRange[1].toISOString()
                    })
                    break
                case 'eventWithLinks':
                    response = await reportsApi.getEventsReport({
                        fleetId: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        vehicleId: this.selectedVehicle,
                        dateFrom: this.dateRange[0].toISOString(),
                        dateTo: this.dateRange[1].toISOString(),
                        includeMediaUris: true
                    })
                    break
                case 'event':
                    response = await reportsApi.getEventsReport({
                        fleetId: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        vehicleId: this.selectedVehicle,
                        dateFrom: this.dateRange[0].toISOString(),
                        dateTo: this.dateRange[1].toISOString(),
                        includeMediaUris: false
                    })
                    break
                case 'snapshotsRequests':
                    let vehicleResponse
                    if (this.selectedVehicle) {
                        vehicleResponse = await vehicleApi.getVehicle(
                            this.selectedVehicle
                        )
                    }
                    response = await mediaRequestApi.getMediaRequests({
                        fleetIds: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        registrationNumber: vehicleResponse
                            ? vehicleResponse.payload.registrationNumber
                            : null,
                        videoTimeFrom: this.dateRange[0].toISOString(),
                        videoTimeTo: this.dateRange[1].toISOString()
                    })
                    break
                case 'deviceLastReported':
                    response = await reportsApi.getDevicesReport({
                        fleetId: this.selectedFleet
                            ? this.selectedFleet.id
                            : null,
                        vehicleId: this.selectedVehicle
                    })
                    break
            }

            if (!response.isSuccess) {
                this.$store.state.isOverlayActive = false
                return
            }

            this.items = response.payload.items
            this.totalItems = response.payload.totalResults
            this.pagination.totalItems = this.totalItems

            this.$store.state.isOverlayActive = false
        },
        prepareDataToSave (isCsv = false) {
            let dataToSave = []
            switch (this.selectedReport) {
                case 'speed':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            fleetName: item.fleetName,
                            vehicleRegistrationNumber:
              item.vehicleRegistrationNumber,
                            time: formatDate(item.time),
                            vehicleSpeed:
                  0 === this.getSpeedUnit
                      ? '' + item.vehicleSpeed
                      : '' +
                      calculateSpeedOrDistanceUnit(
                          item.vehicleSpeed,
                          'mi'
                      ),
                            speedLimit:
                  0 === this.speedLimit
                      ? '' + item.speedLimit
                      : '' +
                      calculateSpeedOrDistanceUnit(
                          item.speedLimit,
                          'mi'
                      )
                        })
                    })

                    break
                case 'journey':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            fleetName: item.fleetName,
                            vehicleRegistrationNumber:
              item.vehicleRegistrationNumber,
                            startTime: formatDate(item.startTime),
                            endTime: formatDate(item.endTime),
                            startLocation: item.startLocation
                                ? `"${item.startLocation}"`
                                : ' ',
                            endLocation: item.endLocation
                                ? `"${item.endLocation}"`
                                : ' ',
                            duration: item.duration,
                            mileage:
                  0 === this.getSpeedUnit
                      ? '' +
                      parseFloat(item.kilometers).toFixed(2)
                      : '' +
                      calculateMileage(item.kilometers, 'mi')
                        })
                    })

                    break
                case 'eventWithLinks':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            eventType: this.getEventName(item.eventType),
                            fleetName: item.fleetName,
                            eventDate: formatDate(item.eventDate),
                            driverName: item.driverName || 'Any',
                            vehicleRegistrationNumber:
              item.vehicleRegistrationNumber,
                            xAxis: 0 <= item.xAxis ? '' + item.xAxis : ' ',
                            yAxis: 0 <= item.yAxis ? '' + item.yAxis : ' ',
                            zAxis: 0 <= item.zAxis ? '' + item.zAxis : ' ',
                            speed:
                  0 === this.getSpeedUnit
                      ? '' + item.speed
                      : '' +
                      calculateSpeedOrDistanceUnit(
                          item.speed,
                          'mi'
                      ),
                            alertLevel: this.getEventLevelName(item.alertLevel),
                            address: item.address || '',
                            latitude: isCsv ? item.latitude || '' : String(item.latitude || '').slice(0, 9),
                            longitude: isCsv ? item.longitude || '' : String(item.longitude || '').slice(0, 9),
                            medias: '"' + item.medias.join('\n') + '"'
                        })
                    })

                    break
                case 'event':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            eventType: this.getEventName(item.eventType),
                            fleetName: item.fleetName,
                            eventDate: formatDate(item.eventDate),
                            driverName: item.driverName || 'Any',
                            vehicleRegistrationNumber:
              item.vehicleRegistrationNumber,
                            xAxis: 0 <= item.xAxis ? '' + item.xAxis : ' ',
                            yAxis: 0 <= item.yAxis ? '' + item.yAxis : ' ',
                            zAxis: 0 <= item.zAxis ? '' + item.zAxis : ' ',
                            speed:
                  0 === this.getSpeedUnit
                      ? '' + item.speed
                      : '' +
                      calculateSpeedOrDistanceUnit(
                          item.speed,
                          'mi'
                      ),
                            alertLevel: this.getEventLevelName(item.alertLevel),
                            address: item.address || '',
                            latitude: isCsv ? item.latitude || '' : String(item.latitude || '').slice(0, 9),
                            longitude: isCsv ? item.longitude || '' : String(item.longitude || '').slice(0, 9)
                        })
                    })

                    break
                case 'snapshotsRequests':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            organizationName: item.organizationName,
                            vehicleRegistrationNumber:
              item.vehicleRegistrationNumber,
                            status: this.getRequestStatusName(item.state),
                            type: this.getRequestTypeName(item.type),
                            createdOn: formatDate(
                                item.createdOn.slice(0, 19) + 'Z'
                            ),
                            createdBy: item.createdByName
                                ? item.createdByName
                                : 'Unknown',
                            modifiedOn: item.modifiedOn
                                ? formatDate(item.modifiedOn)
                                : '-',
                            modifiedBy: item.modifiedByName
                                ? item.modifiedByName
                                : '-'
                        })
                    })

                    break
                case 'deviceLastReported':
                    this.items.forEach((item) => {
                        dataToSave.push({
                            recorderId: item.hardwareId ? item.hardwareId : '-',
                            vehicle: item.vehicle ? item.vehicle.name : '-',
                            organizationName: item.organization
                                ? item.organization.name
                                : '-',
                            fleetName: item.fleet ? item.fleet.name : '-',
                            lastReported: item.lastReported
                                ? formatDate(item.lastReported)
                                : '-',
                            enabled: item.enabled ? 'YES' : 'NO'
                        })
                    })

                    break
            }

            return dataToSave
        },
        showEvent (payload) {
            this.$store.commit('setEventId', payload)
        },
        getDataUri (url, cb) {
            let image = new Image()
            image.setAttribute('crossOrigin', 'anonymous')
            image.onload = function () {
                let canvas = document.createElement('canvas')
                canvas.width = this.naturalWidth
                canvas.height = this.naturalHeight
                canvas.getContext('2d').drawImage(this, 0, 0)

                cb(canvas.toDataURL('image/png'))
            }

            image.src = url
        },
        exportToPDF () {
            // eslint-disable-next-line new-cap
            const pdf = new jsPDF({
                orientation: 'p',
                putOnlyUsedFonts: true,
                format: 'a4',
                unit: 'px'
            })

            const img = new Image()
            if (this.getReportImageUri) {
                this.getDataUri(this.getReportImageUri, (dataUri) => {
                    img.src = dataUri

                    const headers = this.exports[this.selectedReport].headers

                    let dataToSave = this.prepareDataToSave()

                    const parsedToPdfAutoTable = dataToSave.map(item => headers.map(head => (item[head.id] ? item[head.id] : '')))
                    pdf.addImage(img, 'png', 150, 10, 152, 18)
                    const styles = this.additionalStyles[this.selectedReport]
                    autoTable(
                        pdf, {
                            showHead: 'everyPage',
                            startY: 30,
                            head: [headers.map(item => item.prompt)],
                            body: parsedToPdfAutoTable,
                            theme: 'grid',
                            margin: 5,
                            headStyles: {
                                fillColor: [210, 210, 210],
                                textColor: 'black',
                                lineColor: 'black',
                                lineWidth: 0.7
                            },
                            styles: {
                                lineColor: 'black',
                                textColor: 'black',
                                lineWidth: 0.7,
                                fontSize: styles ? styles.fontSize : 9
                            }
                        }
                    )

                    pdf.save(
                        `${
                            this.exports[this.selectedReport].fileName
                        }_${moment().format('DD-MM-YYYYTHH_mm_ss')}.pdf`,
                        {
                            top: 40,
                            bottom: 40,
                            left: 40
                        }
                    )
                    /*                    pdf.table(
    10,
    40,
    dataToSave,
    this.exports[this.selectedReport].headers,
    {
        fontSize: 10
    }
) */

                    /*                    pdf.save(
    `${
        this.exports[this.selectedReport].fileName
    }_${moment().format('DD-MM-YYYYTHH_mm_ss')}.pdf`,
    {
        top: 40,
        bottom: 40,
        left: 40
    }
) */
                })
            } else {
                img.src = require('@/assets/images/logo-black.png')

                const headers = this.exports[this.selectedReport].headers

                let dataToSave = this.prepareDataToSave()

                const parsedToPdfAutoTable = dataToSave.map(item => headers.map(head => (item[head.id] ? item[head.id] : '')))
                pdf.addImage(img, 'png', 150, 10, 152, 18)
                const styles = this.additionalStyles[this.selectedReport]

                autoTable(
                    pdf, {
                        showHead: 'everyPage',
                        startY: 30,
                        head: [headers.map(item => item.prompt)],
                        body: parsedToPdfAutoTable,
                        theme: 'grid',
                        margin: 5,
                        headStyles: {
                            fillColor: [210, 210, 210],
                            textColor: 'black',
                            lineColor: 'black',
                            lineWidth: 0.7
                        },
                        styles: {
                            lineColor: 'black',
                            textColor: 'black',
                            lineWidth: 0.7,
                            fontSize: styles ? styles.fontSize : 9
                        }
                    }
                )

                pdf.save(
                    `${
                        this.exports[this.selectedReport].fileName
                    }_${moment().format('DD-MM-YYYYTHH_mm_ss')}.pdf`,
                    {
                        top: 40,
                        bottom: 40,
                        left: 40
                    }
                )
            }
        },
        exportToCSV () {
            let dataToSave = this.prepareDataToSave(true)

            let csvContent = 'data:text/csv;charset=utf-8,'
            let headerArray = Object.keys(dataToSave[0]).map((el) => {
                return camelCaseToSentence(el)
            })

            csvContent += [
                headerArray.join(';'),
                ...dataToSave.map((item) => Object.values(item).join(';'))
            ]
                .join('\n')
                .replace(/(^\[)|(\]$)/gm, '')

            const data = encodeURI(csvContent)
            const link = document.createElement('a')
            link.setAttribute('href', data)
            link.setAttribute(
                'download',
                `${
                    this.exports[this.selectedReport].fileName
                }_${moment().format('DD-MM-YYYYTHH_mm_ss')}.csv`
            )
            link.click()
        },
        exportToXlsx(){
            let dataToSave = this.prepareDataToSave(true);
            let headerArray = Object.keys(dataToSave[0]).map((el) => {
                return camelCaseToSentence(el)
            })

            const worksheet = utils.json_to_sheet(dataToSave);
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, "Data");

            utils.sheet_add_aoa(worksheet, [headerArray], { origin: "A1" });

            writeFileXLSX(workbook, `${
                this.exports[this.selectedReport].fileName
            }_${moment().format('DD-MM-YYYYTHH_mm_ss')}.xlsx`);
        },
        dateFormat (date) {
            return formatDate(date)
        },
        getRequestStatusName (requestStatusID) {
            return searchEnumById(this.getDeviceCommandStates, requestStatusID)
        },
        getRequestTypeName (requestTypeID) {
            return searchEnumById(this.getDeviceCommandTypes, requestTypeID)
        },
        getEventName (eventId) {
            const event = searchEnumById(this.getEventTypes, eventId[0])

            if (null === event) {
                return '-'
            } else {
                return event
            }
        },
        getEventLevelName (levelId) {
            const level = searchEnumById(this.getEventClassifications, levelId)

            if (null === level) {
                return '-'
            } else {
                return level
            }
        }
    }
}
</script>

<style lang="scss">
.custom-table-style {
  .v-table {
    tr {
      th, td {
        padding: 0 6px !important;
      }
    }
  }

}

</style>

<style scoped lang="scss">

.overview {
  display: flex;
  padding-top: 30px;

  .page-title {
    align-items: center;
    display: flex;
    position: relative;
    top: -12px;
    margin-right: 30px;
    font-weight: bold;
  }

  .filters {
    display: flex;

    .filter {
      margin: 0 10px;
      position: relative;

      .daterange-error {
        position: absolute;
        font-size: 12px;
        bottom: -10px;
        white-space: nowrap;
      }
    }
  }
}

.table-buttons {
  .v-btn:not(:last-child) {
    margin-right: 10px !important;
  }
}

::v-deep .mx-input {
  height: 48px;
}

.custom-table-style {
  tr {
    td {
      padding: 0 6px;
    }
  }

}

</style>
